import axios from '@/helpers/axios';
import { numberPortApi } from '@/helpers/apis';
import mobileOperatorsMock from '../../../__mocks__/number-port-mock.json';

export const getMobileOperatorValues = () => {
  return Promise.resolve(mobileOperatorsMock.mobileOperators);
};

export const checkNumberPort = (requestData) => {
  const url = numberPortApi.NUMBER_PORT_ELIGIBILITY;
  return axios.post(url, requestData);
};
